<template>
  <div>
    <PrimaryBox :flag="true">
      <template slot="title">
        <span>里程统计</span>
      </template>
      <div class="content">
        <div class="echartsBox">
          <Icon type="ios-loading" size="40" style="margin-top: 20%" v-if="mileageLoading"
                class="xvanzhuan"/>
          <div v-if="!mileageLoading" id="mileage"></div>
        </div>
      </div>
    </PrimaryBox>
  </div>
</template>
<script>
import PrimaryBox from "@/views/Screen/components/PrimaryBox/PrimaryBox.vue";
import * as echarts from "echarts";

export default {
  components: {
    PrimaryBox
  },
  data() {
    return {
      mileageLoading: false,
      county: '',
      countyList: [],
      MileageRatios: [],
      MileageOptions: {
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: false,
        },
        grid: {
          left: '1%',
          right: '1%',
          bottom: '5%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            interval: 0,
            show: true,
            rotate: 30,
            textStyle: {
              color: '#c3dbff',  //更改坐标轴文字颜色
              fontSize : 12      //更改坐标轴文字大小
            }
          },
        },
        yAxis: {
          type: 'value',
          data: []
        },
        series: []
      },
      MileageDom: null,
    }
  },
  mounted() {
    this.getMileageData()
  },
  methods: {
    // 获取里程比数据
    getMileageData() {
      this.mileageLoading = true
      this.$http.get(`/api/cameraMileageRatios`).then(res => {
        if (res.status === 200) {
          this.mileageLoading = false
          this.MileageRatios = res.data.data
          let mileageRatio = []
          let mileage = []
          for (let i in this.MileageRatios) {
            this.MileageOptions.xAxis.data.push(this.MileageRatios[i].deptName)
            mileageRatio.push(this.MileageRatios[i].mileageRatio)
            mileage.push(this.MileageRatios[i].mileage)
            this.MileageOptions.series[2] = {
              type: 'bar',
              label: {
                show: true,
                position: 'top',
                fontSize: 10,
                offset: [2, -10],
                color: '#00FFFF'
              },
              itemStyle: {
                color: 'transparent',
              },
              tooltip: {},
              data: mileage,
            }
            this.MileageOptions.series[1] = {
              name: '里程比',
              type: 'line',
              data: mileageRatio,
              color: '#00FFFF',
              label: {
                show: true,
                position: 'top',
                color: '#00FFFF'
              },
            }
            this.MileageOptions.series[0] = {
              name: '里程',
              type: 'custom',
              data: mileage,
              color: '#007bf4',
              renderItem: (params, api) => {
                return this.getRenderItem(params, api);
              },
              barWidth: 15,
            }
          }
          this.$nextTick(() => {
            this.drawMileageChart()
          })
        }
      })
    },
    getRenderItem(params, api) {
      const index = params.seriesIndex;
      let location = api.coord([api.value(0) + index, api.value(1)]);
      let extent = api.size([0, api.value(1)]);
      return {
        type: 'group',
        children: [
          {
            type: 'leftRect',
            shape: {
              api,
              xValue: api.value(0) + index,
              yValue: api.value(1),
              x: location[0],
              y: location[1],
            },
            style: api.style()
          },
          {
            type: 'rightRect',
            shape: {
              api,
              xValue: api.value(0) + index,
              yValue: api.value(1),
              x: location[0],
              y: location[1],
            },
            style: api.style(),
          }
        ]
      };
    },
    // 绘制里程比图表
    drawMileageChart() {
      this.$nextTick(() => {
        document.getElementById("mileage").style.display = "block";
        document.getElementById("mileage").style.width = "100%";
        this.MileageDom = echarts.init(document.getElementById("mileage"));
        const leftRect = echarts.graphic.extendShape({
          shape: {
            x: 10,
            y: -100,
            width: 8, //柱状图宽
            zWidth: 17, //阴影折角宽
            zHeight: 4, //阴影折角高
          },
          buildPath: function (ctx, shape) {
            const api = shape.api;
            const xAxisPoint = api.coord([shape.xValue, 0]);
            const p0 = [shape.x - shape.width / 2, shape.y - shape.zHeight];
            const p1 = [shape.x - shape.width / 2, shape.y - shape.zHeight];
            const p2 = [xAxisPoint[0] - shape.width / 2, xAxisPoint[1]];
            const p3 = [xAxisPoint[0] + shape.width / 2, xAxisPoint[1]];
            const p4 = [shape.x + shape.width / 2, shape.y];
            ctx.moveTo(p0[0], p0[1]);
            ctx.lineTo(p1[0], p1[1]);
            ctx.lineTo(p2[0], p2[1]);
            ctx.lineTo(p3[0], p3[1]);
            ctx.lineTo(p4[0], p4[1]);
            ctx.lineTo(p0[0], p0[1]);
            ctx.closePath();
          },
        });
        const rightRect = echarts.graphic.extendShape({
          shape: {
            x: 0,
            y: -10,
            width: 8,
            zWidth: 10,
            zHeight: 8,
          },
          buildPath: function (ctx, shape) {
            const api = shape.api;
            const xAxisPoint = api.coord([shape.xValue, 0]);
            const p1 = [shape.x - shape.width / 2, shape.y - shape.zHeight / 2];
            const p3 = [xAxisPoint[0] + shape.width / 2, xAxisPoint[1]];
            const p4 = [shape.x + shape.width / 2, shape.y];
            const p5 = [xAxisPoint[0] + shape.width / 2 + shape.zWidth, xAxisPoint[1]];
            const p6 = [shape.x + shape.width / 2 + shape.zWidth, shape.y - shape.zHeight / 2];
            const p7 = [shape.x - shape.width / 2 + shape.zWidth, shape.y - shape.zHeight];
            ctx.moveTo(p4[0], p4[1]);
            ctx.lineTo(p3[0], p3[1]);
            ctx.lineTo(p5[0], p5[1]);
            ctx.lineTo(p6[0], p6[1]);
            ctx.lineTo(p4[0], p4[1]);
            ctx.moveTo(p4[0], p4[1]);
            ctx.lineTo(p6[0], p6[1]);
            ctx.lineTo(p7[0], p7[1]);
            ctx.lineTo(p1[0], p1[1]);
            ctx.lineTo(p4[0], p4[1]);
            ctx.closePath();
          },
        });
        echarts.graphic.registerShape('leftRect', leftRect);
        echarts.graphic.registerShape('rightRect', rightRect);
        this.MileageDom.setOption(this.MileageOptions);
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "mileages";

#mileage {
  width: 100%;
  height: 100%;
}


@keyframes xvanzhuan {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg)
  }
}

.xvanzhuan {
  animation: xvanzhuan 1s linear infinite;
}
</style>
